import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineLatest } from 'rxjs';
import { EventResource } from 'src/app/interfaces/event-resource';
import { EventService } from 'src/app/services/event.service';
import { PropertyService } from 'src/app/services/property.service';
/**
 * The Data to be passed into the Dialog
 */

export interface DialogData {
  /**
   * The Title of the Dialog
   */
  title: string;
  /**
   * The message in the Dialog
   */
  message: string;
  /**
   * The okText on the Button
   */
  okText: string;
  /**
   * The cancelText on the Button
   */
  cancelText: String;
  /**
   * The Event
   */
  event: EventResource;
}
/**
 * The Dialog to inform the User what the automatic Statechange means
 */
@Component({
  selector: 'app-auto-update-event-status',
  templateUrl: './auto-update-event-status.component.html',
  styleUrls: ['./auto-update-event-status.component.scss']
})
export class AutoUpdateEventStatusComponent implements OnInit {
  state_change_draft_preview: number | null = null;
  state_change_preview_active: number | null = null;
  state_change_active_expired: number | null = null;
  state_change_expired_archived: number | null = null;
  /**
   * constructor
   * @param data 
   * @param dialogRef 
   * @param eventService 
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<AutoUpdateEventStatusComponent>,
    private eventService: EventService,
    private propertyService: PropertyService
  ) {
    combineLatest([
      this.propertyService.getStateChangeDraftPreview('state_change_draft_preview'),
      this.propertyService.getStateChangeDraftPreview('state_change_preview_active'),
      this.propertyService.getStateChangeDraftPreview('state_change_active_expired'),
      this.propertyService.getStateChangeDraftPreview('state_change_expired_archived'),
    ]).subscribe({
      next: (res: Array<any>) => {
        console.log(res)
        this.state_change_draft_preview = res[0].value;
        this.state_change_preview_active = res[1].value;
        this.state_change_active_expired = res[2].value;
        this.state_change_expired_archived = res[3].value;
      }
    })
  }
  /**
   * ngOnInit
   */
  ngOnInit(): void {
  }
  /**
   * Close the Dialog
   */
  cancel(): void {
    this.dialogRef.close(false);
  }
  /**
   * Start the bulkupdate for the Events
   */
  update() {
    this.eventService.bulkUpdateEvents(false).subscribe(() => {
      this.dialogRef.close(true);
    });
  }
}
